export const EVENT_LOCAL_STORAGE_UPDATE_MY_INFO = "myInfo";
export const EVENT_LOCAL_STORAGE_LOGIN = "login";
export const EVENT_LOCAL_STORAGE_LOGOUT = "logout";
